import React from 'react';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import Button from './Button';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  current?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className }) => {
  return (
    <nav className={clsx('flex', className)} aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-2">
        {/* Home link */}
        <li>
          <div>
            <Button to="/" variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground p-1">
              <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">Home</span>
            </Button>
          </div>
        </li>
        
        {items.map((item, index) => (
          <li key={index}>
            <div className="flex items-center">
              <ChevronRightIcon
                className="h-5 w-5 flex-shrink-0 text-muted-foreground"
                aria-hidden="true"
              />
              {item.href && !item.current ? (
                <Button
                  to={item.href}
                  variant="ghost"
                  size="sm"
                  className="ml-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors p-1"
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.label}
                </Button>
              ) : (
                <span
                  className={clsx(
                    'ml-2 text-sm font-medium',
                    item.current
                      ? 'text-foreground'
                      : 'text-muted-foreground'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;